import React from "react";
import DraggableTable from "common/Components/DraggableTable";
import styles from "./DraggableTableWrapperStyles.module.css";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { MobileCustomRow } from "./modules/MobileCustomRow/MobileCustomRow";

export const DraggableTableWrapper = (props) => {
  const isDesktop = useDesktopMediaQuery();
  return (
    <DraggableTable
      customTableStyles={{
        thead: styles.thead,
        tr: styles.tr,
        tbody: styles.tbody,
        table: styles.table,
      }}
      disabledAreaWarningMsg={
        <>
          <b>First 4 questions can&apos;t be moved!</b> They&apos;re required
          for lead collection.
        </>
      }
      {...(!isDesktop && { CustomRow: MobileCustomRow })}
      {...props}
    />
  );
};
